import React from 'react';
import dayjs from 'dayjs';
import { Form, Button, Modal, Icon, Radio, DatePicker, Breadcrumb, Tooltip } from '@roo/roo';
import Upload from 'RooV1.12/Upload';
import { Row, Col } from '@roo/roo/Grid';
import { Textarea } from '@roo/roo/Input';
import { FileModel } from '@roo/roo/Upload/interface';
import request from '@/utils/request';
import utils from '@/utils/utils';
import urlUtil from '@/utils/url';

import './editor.scss';

const Field = Form.field;
// @ts-ignore
const RadioGroup = Radio.Group;

// const RadioGroup = Radio.Group;

interface IState {
    img1ShowAdd: boolean;
    img2ShowAdd: boolean;
    upload1DefaultList: FileModel[];
    upload2DefaultList: FileModel[];
    mode: string; // ceate 新建，edit 编辑 用来组件重渲染
    tipVisible: boolean;
}

interface IProps {
    history: any;
    editData: any;
}

interface FormData {
    title: string; // 标题
    introduction: string; // 简介
    previewPicUrl: string; // 宣传图片一 （1:1）
    coverPicUrl: string; // 宣传封面二 （16：9）
    startTime: number | undefined; // 开始时间（时间戳）
    type: number | undefined; // 直播样式 1.竖屏 2.横屏
}

class Editor extends React.Component<IProps, IState> {
    formData: FormData = {
        title: '',
        introduction: '',
        previewPicUrl: '',
        coverPicUrl: '',
        startTime: undefined,
        type: 1,
    };

    rules = {
        title: {
            required: true,
            max: 10,
            message: '请输入直播主题，10个字符以内',
        },
        introduction: {
            required: true,
            message: '请输入直播简介',
        },
        previewPicUrl: {
            required: true,
            validator: (_rule: any, _value: any, callback: any) => {
                const { img1ShowAdd } = this.state;
                if (img1ShowAdd) {
                    callback('请上传合适的图片');
                } else {
                    callback();
                }
            },
        },
        coverPicUrl: {
            required: true,
            validator: (_rule: any, _value: any, callback: any) => {
                const { img2ShowAdd } = this.state;
                if (img2ShowAdd) {
                    callback('请上传合适的图片');
                } else {
                    callback();
                }
            },
        },
        startTime: {
            required: true,
            validator: (rule: any, value: number, callback: any) => {
                if (!value) {
                    callback('请选择开始时间');
                } else if (Date.now() > value) {
                    callback('开始时间必须大于当前时间');
                } else {
                    callback();
                }
            },
        },
        type: {
            required: true,
            message: '请选择直播样式',
        },
    };

    params: any = {};

    remoteData: any = {}; // 编辑页面时，服务端初始数据

    constructor(props: IProps) {
        super(props);
        this.state = {
            img1ShowAdd: true,
            img2ShowAdd: true,
            upload1DefaultList: [],
            upload2DefaultList: [],
            mode: 'create',
            tipVisible: false,
        };
        this.params = utils.urlParse();
    }

    async componentDidMount() {
        if (this.params.liveId) {
            try {
                this.editInit();
            } catch (e) {
                console.log('获取编辑页面初始化信息错误');
            }
        }
    }

    /**
     * 编辑时，请求接口获取编辑前的数据
     */
    editInit = async () => {
        const { liveId } = this.params;
        const result = await request.get('/api/live/detail', {
            busId: urlUtil.commonParams.providerId,
            busLine: 1,
            liveId: +liveId,
        });
        this.remoteData = result.data;
        const {
            data: {
                // @ts-ignore
                live: { title, introduction, type, startTime, previewPicUrl, coverPicUrl } = {},
            } = {},
        } = result;
        this.formData = {
            ...this.formData,
            ...{
                title,
                introduction,
                type,
                startTime: startTime * 1000,
                previewPicUrl,
                coverPicUrl,
            },
        };

        this.setState({
            mode: 'edit',
            img1ShowAdd: false,
            img2ShowAdd: false,
            upload1DefaultList: [
                {
                    name: 'previewPicUrl',
                    uid: '000000',
                    url: previewPicUrl,
                    status: 'success',
                    size: 0,
                    type: 'init',
                },
            ],
            upload2DefaultList: [
                {
                    name: 'coverPicUrl',
                    uid: '111111',
                    url: coverPicUrl,
                    status: 'success',
                    size: 0,
                    type: 'init',
                },
            ],
        });
    };

    validityCallback = (ratio: number, files: FileModel[]) => {
        const maxSize = 2 * 1024 * 1024; // 最大10m
        const filesArr = Array.prototype.slice.call(files);
        if (filesArr[0].size > maxSize) {
            utils.toast('warning', '文件不能大于2M');
            return false;
        }
        return this.isSuitableSync(files[0], ratio);
    };

    handleUploadChange = (imgK: number, setValue: any, file: FileModel, fileList: FileModel[]) => {
        const _imgAdds = ['img1ShowAdd', 'img2ShowAdd'];
        let imgShowAdd = true;
        if (fileList.length) {
            imgShowAdd = false;
            // @ts-ignore
            if (file.status === 'success' && file.response && file.response.data) {
                try {
                    // @ts-ignore
                    setValue(file.response.data);
                } catch (e) {
                    console.log(e);
                }
            }
        }
        const k = _imgAdds[imgK];
        // @ts-ignore
        this.setState({
            [k]: imgShowAdd,
        });
    };

    goToListPage = () => {
        this.props.history.push('/live/list');
    };

    onSubmit = async (formData, errors: any) => {
        if (errors && errors.length > 0) {
            return;
        }
        const url = this.params.liveId ? '/api/live/reApply' : '/api/live/apply';
        const params = {
            busId: urlUtil.commonParams.providerId,
            busLine: 1,
            ...formData,
            startTime: Math.floor(formData.startTime / 1000),
        };
        if (this.params.liveId) {
            params.liveId = +this.params.liveId;
        }
        const res = await request.post(url, params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (res.code === 0) {
            Modal.confirm({
                title: this.params.liveId ? '更新成功' : '创建成功',
                children: '系统会自动对信息进行审核，约2分钟后出审核结果',
                status: 'success',
                onConfirm: () => {
                    this.goToListPage();
                },
                backdropClosable: false,
            });
        }
    };

    imgUploadFail = (err: any) => {
        console.log('imgfail:', err);
    };

    /**
     * 异步获取图片是否符合宽高要求
     * （高 * 宽比高比例 - 宽）的绝对值小于 5 则符合要求
     * @param file FileModel 文件对象
     * @param ratio 宽：高 比例
     * @return Promise
     */
    isSuitableSync = (file: any, ratio: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise(resolve => {
            reader.onload = function (e) {
                const image = new Image();
                // @ts-ignore
                image.src = e.target.result;
                image.onload = function () {
                    // @ts-ignore
                    if (Math.abs(this.height * ratio - this.width) < 5) {
                        return resolve(true);
                    }
                    utils.toast('warning', '图片尺寸不符合要求');
                    return resolve(false);
                };
            };
        });
    };

    render() {
        const { state, rules, goToListPage, onSubmit, validityCallback, imgUploadFail } = this;
        const {
            mode,
            img1ShowAdd,
            img2ShowAdd,
            upload1DefaultList,
            upload2DefaultList,
            tipVisible,
        } = state;
        const cols = {
            label: { span: 2 },
            field: { span: 10 },
        };
        return (
            <div className="live-edit">
                <Breadcrumb
                    type="oblique"
                    items={[
                        {
                            text: '直播管理',
                            onClick: () => {
                                this.props.history.push('/live/list');
                            },
                        },
                        {
                            text: this.params.liveId ? '编辑直播' : '创建直播',
                        },
                    ]}
                />
                <Form value={this.formData} rules={rules} cols={cols} onSubmit={onSubmit}>
                    {({ submitForm }) => (
                        <form>
                            {/* 直播主题 */}
                            <Field
                                label="直播主题"
                                name="title"
                                // @ts-ignore
                                style={{ width: 318 }}
                                placeholder="请用一句话介绍您的直播内容"
                            />
                            {/* 直播简介 */}
                            <Field label="直播简介" name="introduction">
                                {({ value, handleChange }) => (
                                    <Textarea
                                        value={value}
                                        placeholder="请简要介绍您的直播内容"
                                        onChange={handleChange}
                                        maxLength={200}
                                        statistics
                                        resize="none"
                                        rows={5}
                                        cols={40}
                                    />
                                )}
                            </Field>

                            {/* 宣传封面 */}
                            <Field label="宣传封面">
                                <div className="upload-group">
                                    {/* 竖屏全屏 */}
                                    <Field withLabel={false} name="previewPicUrl">
                                        {({ handleChange }) => (
                                            <div className="upload-item">
                                                <Upload
                                                    key={mode}
                                                    defaultFileList={upload1DefaultList}
                                                    showUploadList
                                                    // @ts-ignore
                                                    validityCallback={(...args: any[]) =>
                                                        // @ts-ignore
                                                        validityCallback(1, ...args)
                                                    }
                                                    showType="card"
                                                    name="img"
                                                    onFail={imgUploadFail}
                                                    onChange={(...args) =>
                                                        this.handleUploadChange(
                                                            0,
                                                            handleChange,
                                                            // @ts-ignore
                                                            ...args,
                                                        )
                                                    }
                                                    action="/api/live/imgUpload"
                                                >
                                                    {img1ShowAdd && (
                                                        <div
                                                            className="upload-add"
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'space-evenly',
                                                                alignItems: 'center',
                                                                cursor: 'pointer',
                                                                height: '100%',
                                                            }}
                                                        >
                                                            <Icon name="plus" size={30} />
                                                            <div>点击上传</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <p className="upload-tip c-tips">
                                                    尺寸1:1，大小&lt;2M
                                                </p>
                                            </div>
                                        )}
                                    </Field>

                                    {/* 横屏展示 */}
                                    <Field withLabel={false} name="coverPicUrl">
                                        {({ handleChange }) => (
                                            <div className="upload-item">
                                                <Upload
                                                    key={mode}
                                                    defaultFileList={upload2DefaultList}
                                                    showUploadList
                                                    // @ts-ignore
                                                    validityCallback={(...args: any[]) =>
                                                        // @ts-ignore
                                                        validityCallback(16 / 9, ...args)
                                                    }
                                                    name="img"
                                                    showType="card"
                                                    onFail={imgUploadFail}
                                                    className="img2-ct"
                                                    onChange={(...args) =>
                                                        this.handleUploadChange(
                                                            1,
                                                            handleChange,
                                                            // @ts-ignore
                                                            ...args,
                                                        )
                                                    }
                                                    action="/api/live/imgUpload"
                                                >
                                                    {img2ShowAdd && (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'space-evenly',
                                                                alignItems: 'center',
                                                                cursor: 'pointer',
                                                                height: '100%',
                                                            }}
                                                        >
                                                            <Icon name="plus" size={30} />
                                                            <div>点击上传</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                                <p className="upload-tip c-tips">
                                                    尺寸16:9，大小&lt;2M
                                                </p>
                                            </div>
                                        )}
                                    </Field>
                                    <div className="cover-tip-img">
                                        <Tooltip
                                            placement="top"
                                            manual
                                            visible={tipVisible}
                                            content={
                                                <div
                                                    style={{
                                                        display: 'inline-block',
                                                        textAlign: 'center',
                                                        minHeight: 340,
                                                    }}
                                                >
                                                    <img
                                                        style={{ width: '100%' }}
                                                        src={require('@/assets/images/live-show-tip.png')}
                                                    />
                                                    <Button
                                                        onClick={() => {
                                                            this.setState({
                                                                tipVisible: false,
                                                            });
                                                        }}
                                                        style={{ marginTop: 10 }}
                                                    >
                                                        我知道了
                                                    </Button>
                                                </div>
                                            }
                                            effect="light"
                                            style={{ color: '#00abe4' }}
                                        >
                                            <Button
                                                style={{ position: 'absolute', bottom: 24 }}
                                                onClick={() => {
                                                    this.setState({
                                                        tipVisible: true,
                                                    });
                                                }}
                                                type="text"
                                            >
                                                封面展示位置示例图
                                            </Button>
                                        </Tooltip>
                                    </div>
                                </div>
                            </Field>

                            {/* 开始时间 */}
                            <Field name="startTime" label="开始时间">
                                {({ value, handleChange }) => (
                                    <Row>
                                        <div className="upload-date">
                                            <Col span={4}>
                                                <DatePicker
                                                    value={value}
                                                    valueOfType="timestamp"
                                                    showTime
                                                    placeholder="请选择时间"
                                                    format="YYYY-MM-DD HH:mm"
                                                    onChange={handleChange}
                                                    disabledDate={cur =>
                                                        cur.isBefore(dayjs().subtract(1, 'day'))
                                                    }
                                                    // @ts-ignore
                                                    popupContainer={() =>
                                                        document.querySelector('.upload-date')
                                                    }
                                                />
                                            </Col>
                                            <Col>
                                                <p className="c-tips">
                                                    注：直播有效期限为24个小时，开始时间的24小时后直播间自动关闭
                                                </p>
                                            </Col>
                                        </div>
                                    </Row>
                                )}
                            </Field>
                            {/* 直播样式 单选 */}
                            <Field name="type" label="直播样式">
                                {({ value, handleChange }) => (
                                    <div className="radio-ct">
                                        <RadioGroup value={value} onChange={handleChange}>
                                            <Row>
                                                <Col className="type-radio-ct" span={2}>
                                                    <Radio value={1}>全屏展示</Radio>
                                                    {/* <div className="type-show1">
                                                            视频区
                                                        </div> */}
                                                </Col>
                                                <Col className="type-radio-ct" span={2}>
                                                    <Radio value={2}>横屏展示</Radio>
                                                    {/* <div className="type-show-bg">
                                                            <div className="type-show2">
                                                                视频区
                                                            </div>
                                                        </div> */}
                                                </Col>
                                            </Row>
                                        </RadioGroup>
                                    </div>
                                )}
                            </Field>
                            <Field>
                                <Row>
                                    <Col span={8}>
                                        <p className="c-tips tip-type">
                                            注：全屏展示即视频要铺满整个手机屏幕，通常用来与使用场景相结合的方式进行产品介绍；
                                            横屏展示即视频区较宽，通常适合授课或者需要宽阔的视野来呈现的场景。
                                        </p>
                                    </Col>
                                </Row>
                            </Field>
                            <Field>
                                <Row>
                                    <Col span={2}>
                                        <Button onClick={goToListPage}>取消</Button>
                                    </Col>
                                    <Col span={2}>
                                        <Button onClick={submitForm}>确认</Button>
                                    </Col>
                                </Row>
                            </Field>
                        </form>
                    )}
                </Form>
            </div>
        );
    }
}

export default Editor;
